import React, { useCallback, useEffect, useRef, useState } from 'react'
import axios from 'axios'
import upperFirst from 'lodash/upperFirst'
import lowerCase from 'lodash/lowerCase'
import Checkbox from '@mui/material/Checkbox'
import { t } from '../../../i18n'
import SectionTitle from '../../shared/sectionTitle'
import FlashNotification from '../../shared/flashNotification'

const scope = 'command_steps'

const RobotCommandStep = ({ step, setSuccessMessage }) => {
  const [stepLength, setStepLength] = useState(step.step_length)
  const [errors, setErrors] = useState([])

  const handleLengthUpdate = (length) => {
    setStepLength(length)
    if(length < 1) {
      setErrors([t('invalid_duration', { scope })])
    } else {
      setErrors([])
    }
  }


  const onSave = () => {
    axios.patch(`/admin/robot_command_steps/${step.id}`, {command_step: {step_length: stepLength}})
    .then(() => {
      setSuccessMessage(t('step_updated_successfully', { scope}))
    }).catch(({ response }) => {
      setErrors(response.data)
    })
  }

  return (
    <tr style={{height: '63px'}} id={step.step_name.replaceAll("_", "-")}>
      <td className="align-middle">{upperFirst(lowerCase(step.step_name))}</td>
      <td className="align-middle">{step.step_number}</td>
      <td className="align-middle">
      <Checkbox checked={step.depends_on_product_container} disabled/>
      </td>
      <td className="align-middle">
        {step.configurable
        ?  <div>
            <div>
              <input
                type="number"
                name="step-length"
                className="form-control step-length"
                value={stepLength}
                onChange={(e) => handleLengthUpdate(e.target.value)}
              />
            </div>
            <span className="error-text" style={{fontSize: '12px'}}> {!!errors.length ? errors.join('; ') : ''} </span>
          </div>
        : t('variable_duration', { scope })
        }
      </td>
      <td className="align-middle">
        {step.depends_on_product_amount ? t('seconds_per_product', { scope }) : t('seconds', { scope })}
      </td>
      <td className="align-middle">
        {step.configurable &&
          <button
            className={`btn btn-primary ${!!errors.length ? 'disabled' : ''}`}
            onClick={onSave}
            disabled={!!errors.length}
          >
            {t('save')}
          </button>
        }
      </td>
    </tr>
  )
}

const RobotCommandSteps = ({ command }) => {
  const [toasterMessage, setToasterMessage] = useState({
    flashType: '',
    flashOpen: false,
    flashMessage: ''
  })

  const setSuccessMessage = (message) => setToasterMessage({ flashType: 'success', flashOpen: true, flashMessage: message })
  const setErrorMessages = (message) => setToasterMessage({ flashType: 'danger', flashOpen: true, flashMessage: message })
  const setInfoMessage = (message) => setToasterMessage({ flashType: 'info', flashOpen: true, flashMessage: message })
  const closeFlash = () => setToasterMessage({ flashOpen: false, flashType: '', flashMessage: '' })

  const renderFlashNotification = () => {
    if (!toasterMessage.flashOpen) return

    return (
      <FlashNotification
        type={toasterMessage.flashType}
        message={toasterMessage.flashMessage}
        onClose={closeFlash}
      />
    )
  }

  return (
    <>
      {renderFlashNotification()}
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={[t('edit_command_steps', { scope }), command.name]} />
        <a href="/admin/robot_commands" className="btn btn-secondary" role="button">
          <i style={{marginRight: '5px'}} className="bi bi-chevron-left"/>
          {t('back_to_commands', { scope })}
        </a>
      </div>
      <table className="table table-hover">
        <thead>
          <tr>
            <th>{t('step_name', { scope })}</th>
            <th>{t('step_number', { scope })}</th>
            <th>{t('depends_on_product_container', { scope })}</th>
            <th>{t('step_duration', { scope })}</th>
            <th>{t('duration_unit', { scope })}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {command.command_steps.map((step, index) => (
            <RobotCommandStep key={index} step={step} setSuccessMessage={setSuccessMessage} />
          ))}
        </tbody>
      </table>
    </>
  )
}

export default RobotCommandSteps
